<template>
  <div class="page-shell">
    <PageBanner
      eyebrow="NEWS"
      background-image="/page/news-banner.jpg"
      :title="{ 'zh-CN': '新闻动态', 'en-US': 'News' }"
      :subtitle="{ 'zh-CN': '行业资讯与本站动态栏目', 'en-US': 'Industry and company news sections' }"
    />
    <PageIntro
      :side-title="{ 'zh-CN': '新闻动态', 'en-US': 'News' }"
      :items="newsItems"
      :breadcrumb="{ 'zh-CN': '首页 > 新闻动态', 'en-US': 'Home > News' }"
      :title="{ 'zh-CN': '新闻动态', 'en-US': 'News' }"
      :paragraphs="paragraphs"
    />
  </div>
</template>

<script>
import PageBanner from "../../components/common/PageBanner.vue";
import PageIntro from "../../components/common/PageIntro.vue";
import { navGroups } from "../../data/site";

export default {
  name: "NewsPage",
  components: { PageBanner, PageIntro },
  data() {
    return {
      newsItems: navGroups.find((item) => item.path === "/news").children,
      paragraphs: [
        {
          "zh-CN": "新闻动态模块已经拆分为行业资讯和本站动态两个独立页面。",
          "en-US": "The news module is split into two independent pages: industry news and company news."
        },
        {
          "zh-CN": "后续可以继续调整为图文资讯流、分页列表、推荐阅读或详情页模式。",
          "en-US": "It can later be adjusted into image-text feeds, paginated lists, recommended reading or detail pages."
        }
      ]
    };
  }
};
</script>
